module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    staticClass: "hd"
  }, [_vm._v("权限详情")]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('div', [_c('span', [_vm._v("存储")]), _vm._v("\n      开启存储权限，方便您下载和更新应用\n    ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("照相机")]), _vm._v("\n      允许应用访问设备的日历数据。此权限用于应用展示日历相关功能\n    ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("电话")]), _vm._v("\n      获取设备的标识\n    ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("位置")]), _vm._v("\n      给用户精准推送消息\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-060df45e","hasScoped":true,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/permissions/pages/home.vue
// module id = cHPu
// module chunks = 7